import { fabric } from "fabric";
import DesignTool from "./designtool";
import Animation from "./animation";
import Utils from "./utils";

const MAX_WIDTH_SP = 1024;
const ZOOM_MAX_SIZE = 1.7;
const ZOOM_MIN_SIZE = 1;

class CircleView {
  constructor(container, perimeter) {
    this.container = document.createElement("div");

    /**
     *
     * @type {HTMLElement}
     */
    this.canvas = document.createElement("canvas");

    this.container.width =
      DesignTool.container.size.width ||
      DesignTool.container.target.clientWidth;
    this.container.height =
      DesignTool.container.size.height ||
      DesignTool.container.target.clientHeight;
    this.canvas.width =
      DesignTool.container.size.width ||
      DesignTool.container.target.clientWidth;
    this.canvas.height =
      DesignTool.container.size.height ||
      DesignTool.container.target.clientHeight;

    this.container.appendChild(this.canvas);

    DesignTool.container.target.appendChild(this.container);

    this.circleInfo = {
      color: perimeter.color,
      strokeWidth: this._getWidthBrowser() > MAX_WIDTH_SP ? 4 : 2
    };
  //  perimeter.size += 3.5;

    let radius = perimeter.size / (2 * Math.PI); // radius in mm
    let percent = 0.5;

    if (perimeter.size >= 1000) {
      percent = percent + 0.3;
    } else {
      percent =
        percent +
        (perimeter.size / 100) *
          (this._getWidthBrowser() > MAX_WIDTH_SP ? 0.035 : 0.06);
    }

    let r = (Math.min(this.canvas.width, this.canvas.height) / 2) * percent; // radius in pixel
    DesignTool.unitRatio = r / radius;
    this.r = r;
    this.lastR=0;
    this.items = [];
    this.numbers = [];
    this.ringSizeMin = perimeter.sizeMin;
    this.ringSize = perimeter.size;
    this.ringSizeMax = perimeter.sizeMax+0.01;
    this.rotation = 0;
    this.center = { x: this.canvas.width / 2, y: this.canvas.height / 2 };
    this.down = false;
    this.da = 0;
    this.lastD = 0;
    this.lastScrollTime = 0;
    this.circuit = this.r * 2 * Math.PI;

    this._callbacks = {};

    this._initFabric();
    this.drawCircle();
    this.animating = false;
    this.canvas.width=this.canvas.offsetWidth;
    this.canvas.height=this.canvas.offsetHeight;


    return this;
  }

  /**
   * @private
   */

  _initFabric() {
    fabric.Object.prototype.originX = fabric.Object.prototype.originY =
      "center";
    this.canvas.width=this.canvas.offsetWidth;
    this.canvas.height=this.canvas.offsetHeight;
    this.FabricCanvas = new fabric.Canvas(this.canvas, {
      hoverCursor: "pointer",
      selection: false,
      perPixelTargetFind: true,
      targetFindTolerance: 5
    });

    this.FabricCanvas.setDimensions({width: this.canvas.offsetWidth, height: this.canvas.offsetHeight});

    var that = this;
    var pointer = null;
    that.deltaAll = { x: 0, y: 0 };
    document.getElementById("main-content").classList.remove("disable_rotate");

    this.FabricCanvas.on({
      "mouse:move": function(e) {
        if (that.down) {
          let rad = that.pos2Angle(e.pointer, that.center);
          let d = rad - that.da;
          that.lastD = d;

          var item;
          for (var i = 0; i < that.items.length; i++) {
            item = that.items[i];
            item.angle += d;
            item.updatePos(that.center);
          }
          that.FabricCanvas.renderAll();
          that.da = rad;
          var date = new Date();
          that.lastScrollTime = date.getTime();
        } else {
          if (that.zoom && pointer != null) {
            that.FabricCanvas.renderAll();
            var delta = new fabric.Point(
              e.pointer.x - pointer.x,
              e.pointer.y - pointer.y
            );
            that.FabricCanvas.relativePan(delta);
            pointer = e.pointer;
          } else {
            if (that.animating) {
              return;
            }
            let obj = that.FabricCanvas.getActiveObject();
            if (obj) {
              let idx = that.items.findIndex(function(o) {
                return obj === o.img;
              });
              if (idx >= 0) {
                let angle = that.pos2Angle(e.pointer, that.center);
                let item = that.items[idx];
                item.angle = angle;
                item.updateRotation(that.center);
                that.FabricCanvas.renderAll();
              }
            }
          }
        }
      },
      "mouse:up": function(e) {
        if (that.down) {
          var date = new Date();
          var diff = date.getTime() - that.lastScrollTime;
          if (diff < 20) {
            let d = that.lastD;
            var item;
            that.animating = that.items.length > 0 ? true : false;
            for (var i = 0; i < that.items.length; i++) {
              item = that.items[i];
              Animation.animateItem(
                that,
                item,
                item.angle,
                item.angle + 12 * d,
                Math.abs(d) * 7000,
                i === that.items.length - 1,
                function() {
                  that.animating = false;
                }
              );
            }
          }
        } else {
          if (!that.animating) {
            let obj = that.FabricCanvas.getActiveObject();
            let idx = that.items.findIndex(function(o) {
              return obj === o.img;
            });
            if (idx >= 0) {
              let dropItem = that.items[idx];
              that.items.splice(idx, 1);
              if (
                e.pointer.x < 0 ||
                e.pointer.x > that.center.x * 2 ||
                e.pointer.y < 0 ||
                e.pointer.y > that.center.y * 2
              ) {
                // remove object from canvas
                obj.visible = false;
                that.FabricCanvas.remove(obj);
                //console.log(dropItem);
                let tmpSize=Utils.getRealSizeItem(dropItem);
                let sizeScale= that.ringSize-tmpSize;
                if(that._setSizeCircle(sizeScale)){
                  that._trigger("onchangecircle");
                  that._replaceDrawOldCicle(that);
                }

                that._trigger("onchange");
                that._trigger("onremove");
              } else {
                let angle = that.pos2Angle(
                  {
                    x:
                      e.pointer.x -
                      (that.FabricCanvas.viewportTransform[4] +
                        (that.FabricCanvas.width * that.FabricCanvas.getZoom() -
                          that.FabricCanvas.width) /
                          2),
                    y:
                      e.pointer.y -
                      (that.FabricCanvas.viewportTransform[5] +
                        (that.FabricCanvas.height *
                          that.FabricCanvas.getZoom() -
                          that.FabricCanvas.height) /
                          2)
                  },
                  that.center
                );
                that.insertItem(
                  angle,
                  dropItem,
                  {
                    x:
                      (e.pointer.x - that.FabricCanvas.viewportTransform[4]) /
                      that.FabricCanvas.getZoom(),
                    y:
                      (e.pointer.y - that.FabricCanvas.viewportTransform[5]) /
                      that.FabricCanvas.getZoom()
                  },
                  true
                );
              }
              that.FabricCanvas.renderAll();
            }
          }
          if (that.zoom) {
            pointer = null;
          }
        }
        that.FabricCanvas.renderAll();
        that.down = false;
        that.da = Infinity;
        that.FabricCanvas.discardActiveObject(e);
      },
      "mouse:down": function(e) {
        let obj = that.FabricCanvas.getActiveObject();
        if (obj == null) {
          if (that.zoom) {
            pointer = e.pointer;
          } else {
            let x = e.pointer.x - that.center.x;
            let y = e.pointer.y - that.center.y;
            let r = Math.sqrt(x * x + y * y);
            if (r < that.r * 0.8) {
              that.down = true;
              that.da = that.pos2Angle(e.pointer, that.center);
            }
          }
        }
      },
      "mouse:wheel": function(opt) {
        var delta = opt.e.deltaY;
        var zoom = that.FabricCanvas.getZoom();
        if (delta > 0) {
          zoom = zoom + 0.1;
          if (zoom >= ZOOM_MAX_SIZE){
            zoom = ZOOM_MAX_SIZE;
          }
        } else {
          zoom = zoom - 0.1;
          if (zoom <= ZOOM_MIN_SIZE) {
            zoom = ZOOM_MIN_SIZE;
          }
        }
        that._addCheckZoomClass(zoom);
        that.FabricCanvas.zoomToPoint(
          { x: that.center.x, y: that.center.y },
          Math.round(zoom * 100) / 100
        );
        opt.e.preventDefault();
        opt.e.stopPropagation();

        var z = that.FabricCanvas.getZoom();
        if (z > 1) {
          that.zoom = true;
          document
            .getElementById("main-content")
            .classList.add("disable_rotate");
        } else {
          that.zoom = false;
          document
            .getElementById("main-content")
            .classList.remove("disable_rotate");
        }
        if (z === 1) {
          that.FabricCanvas.absolutePan({ x: 0, y: 0 });
        }
      }
    });
  }

  zoomCircle(beforeW, afterW) {
    var zoom = this.FabricCanvas.getZoom();

    if (afterW > beforeW) {
      zoom = zoom + 0.06;
      if (zoom >= ZOOM_MAX_SIZE){
        zoom = ZOOM_MAX_SIZE;
      }
    } else {
      zoom = zoom - 0.06;

      if (zoom <= ZOOM_MIN_SIZE) {
        zoom = ZOOM_MIN_SIZE;
      }
    }
    this._addCheckZoomClass(zoom);

    this.FabricCanvas.zoomToPoint(
      { x: this.center.x, y: this.center.y },
      Math.round(zoom * 100) / 100
    );

    if (zoom > 1) {
      this.zoom = true;
      document.getElementById("main-content").classList.add("disable_rotate");
    } else {
      this.zoom = false;
      document
        .getElementById("main-content")
        .classList.remove("disable_rotate");
    }

    if (zoom === 1) {
      this.FabricCanvas.absolutePan({ x: 0, y: 0 });
    }
  }

   _addCheckZoomClass(zoom){
    document.getElementById("btn_zoom_in").classList.remove("disabled_button");
    document.getElementById("btn_zoom_out").classList.remove("disabled_button");
     if (zoom == ZOOM_MIN_SIZE) {
       document.getElementById("btn_zoom_out").classList.add("disabled_button");
     }
     if (zoom == ZOOM_MAX_SIZE) {
       document.getElementById("btn_zoom_in").classList.add("disabled_button");
     }
  }

  pos2Angle(p, c) {
    let dx = p.x - c.x;
    let dy = p.y - c.y;
    let dot = dx * (3000 - c.x) + dy * 0;
    let det = dx * 0 + dy * (3000 - c.x);
    let a = Math.atan2(det, dot);
    if (a < 0) {
      a = 2 * Math.PI + a;
    }
    return a;
  }

  drawCircle() {
    this.circle = new fabric.Circle({
      radius: this.r,
      left: this.center.x,
      top: this.center.y,
      fill: "",
      stroke: this.circleInfo.color,
      strokeWidth: this.circleInfo.strokeWidth,
      hasBorders: false,
      hasControls: false,
      lockMovementX: true,
      lockMovementY: true,
      selectable: false,
      hoverCursor: "default",
      index: 0,
      name: "circleImg"
    });
    this.FabricCanvas.add(this.circle);
  }

  drawItems() {
    for (var i = 0; i < this.items.length; i++) {
      let item = this.items[i];
      if (item.angle < 0) {
        let tmp =
          i === 0 ? 0 : this.items[i - 1].angle + this.items[i - 1].a / 2;
        item.angle = tmp + item.a / 2;
      }
      item.updatePos(this.center);

      fabric.Image.fromURL(item.image_design, function(img) {
        img
          .set({
            left: item.pos.x,
            top: item.pos.y,
            scaleX: item.scale,
            scaleY: item.scale,
            angle: item.pos.rotation
          })
          .setCoords();

        img.perPixelTargetFind = true;
        this.container.target.add(img);
        item.img = img;
      });
    }
  }

  getCurrentCircuit() {
    return this.items.reduce(function(total, item) {
      let size = Utils.getRealSizeItem(item);
      return total + size;
      // return total + item.c;
    }, 0);
  }

  addItemChangeSize(item, oldItems) {
    let i = this.items.length;
    let tmpSize = Utils.getRealSizeItem(item);

    if (
      parseFloat((this.getCurrentCircuit() + tmpSize-0.01).toFixed(2)) >
      this.ringSize
    ) {
      this._trigger("onfull");
      return false;
    }

    if (item.angle < 0) {
      let tmp = i === 0 ? 0 : this.items[i - 1].angle + this.items[i - 1].a / 2;
      item.angle = tmp + item.a / 2;
    }

    if (i >= 1) {
      if (oldItems[i].angle - oldItems[i - 1].angle < 1) {
        let tmp = this.items[i - 1].angle + this.items[i - 1].a / 2;
        item.angle = tmp + item.a / 2;
      }

      let firstAngle = item.getFirstAngle();
      let middleAngle = item.angle;
      let lastAngle = item.getLastAngle();

      for (let j = 0; j < this.items.length; j++) {
        let newAngle = lastAngle + this.items[j].a / 2;

        if (
          Utils.isIntersectedCurves(
            firstAngle,
            lastAngle,
            this.items[j].getFirstAngle(),
            this.items[j].getLastAngle()
          ) ||
          Utils.isBetweenAngle(this.items[j].angle, middleAngle, newAngle)
        ) {
          if (newAngle - Math.PI * 2 > this.items[j].angle) {
            newAngle -= Math.PI * 2;
          } else if (newAngle < this.items[j].angle) {
            newAngle += Math.PI * 2;
          }
        } else {
          newAngle = this.items[j].angle;
        }

        this.items[j].angle = newAngle;
        this.items[j].updatePos(this.center);

        firstAngle = Utils.normalizeAngle(newAngle - this.items[j].a / 2);
        middleAngle = this.items[j].angle;
        lastAngle = Utils.normalizeAngle(newAngle + this.items[j].a / 2);
      }
    }

    this.items.push(item);
    item.updatePos(this.center);
    let that = this;
    fabric.Image.fromURL(
      item.imageURL.replace(/^https:\/\//i, "http://"),
      function(img) {
        item.updateSizes(img.width, img.height);
        img.set({
          left: item.pos.x,
          top: item.pos.y,
          scaleX: item.scale,
          scaleY: item.scale,
          angle: item.pos.rotation
        });

        img.perPixelTargetFind = true;
        that.FabricCanvas.add(img);
        that.FabricCanvas.renderAll();
        item.img = img;
      },
      {
        crossOrigin: "anonymous",
        // remove borders and corners but leaving object available for events
        hasBorders: false,
        hasControls: false
      }
    );
    this._trigger("onchange");
    return true;
  }

  addItem(item) {
    let i = this.items.length;
    let ringSizeMax = this.ringSizeMax != null ? this.ringSizeMax : this.ringSize
    let tmpSize = Utils.getRealSizeItem(item);
    if (
      parseFloat((this.getCurrentCircuit() + tmpSize-0.01).toFixed(2)) >
        ringSizeMax
    ) {
      this._trigger("onfull");
      return false;
    }
    if (item.angle < 0) {
      let tmp = i === 0 ? 0 : this.items[i - 1].angle + this.items[i - 1].a / 2;
      item.angle = tmp + item.a / 2;
    }

    this.items.push(item);
    item.updatePos(this.center);
    let that = this;
    fabric.Image.fromURL(
      item.imageURL.replace(/^https:\/\//i, "http://"),
      function(img) {
        item.updateSizes(img.width, img.height);
        img.set({
          left: item.pos.x,
          top: item.pos.y,
          scaleX: item.scale,
          scaleY: item.scale,
          angle: item.pos.rotation
        });

        img.perPixelTargetFind = true;
        that.FabricCanvas.add(img);
        that.FabricCanvas.renderAll();
        item.img = img;
      },
      {
        crossOrigin: "anonymous",
        // remove borders and corners but leaving object available for events
        hasBorders: false,
        hasControls: false
      }
    );
    this._trigger("onchange");
    return true;
  }

  addItemChangeSizeCircle(item,angle, dropItem, pointer,goToEnd) {
    //console.log("circleview Tool addItemLVC2a......dddd a4");
    let i = this.items.length;
    item.circleRadius=this.r;
    if (item.angle < 0) {
      let tmp = i === 0 ? 0 : this.items[i - 1].angle + this.items[i - 1].a / 2;
      item.angle = tmp + item.a / 2;
    }
    let that = this;

    fabric.Image.fromURL(item.imageURL.replace(/^https:\/\//i, "http://"), function (img) {
      item.updateSizes(img.width, img.height);
      img.set({
        left: item.pos.x,
        top: item.pos.y,
        scaleX: item.scale,
        scaleY: item.scale,
        angle: item.pos.rotation
      });
      item.updatePos(that.center);
      img.perPixelTargetFind = true;
      item.img = img;
      that.FabricCanvas.add(img);
      that.items.push(item);
      if(goToEnd){
        that.FabricCanvas.renderAll();
        //that._trigger("onchange");
        setTimeout(() => {
          that._insertItem(that, angle, dropItem, pointer);
          that.FabricCanvas.renderAll();
          that._trigger("onchange");
        }, 200);
      }
      
    }, {
      crossOrigin: "anonymous",
      // remove borders and corners but leaving object available for events
      hasBorders: false,
      hasControls: false
    });
    
   // this._trigger("onchange");
    return true;
  }
  addItemChangeSizeCircleNew(that,location) {
    //console.log("circleview Tool addItemLVC2a......dddd a4");
    let i = that.items.length;
    let item=that.items[location];
    that.items[location].circleRadius = that.r;
    if (item.angle < 0) {
      let tmp = i === 0 ? 0 : that.items[i - 1].angle + that.items[i - 1].a / 2;
      item.angle = tmp + item.a / 2;
    }
    that.items[location].updateSizes(that.items[location].img.width, that.items[location].img.height);
    that.items[location].img.set({
      left: item.pos.x,
      top: item.pos.y,
      scaleX: item.scale,
      scaleY: item.scale,
      angle: item.pos.rotation
    });
    that.items[location].updatePos(that.center);
    that.items[location].img.perPixelTargetFind = true;

   /* Animation.animateLine(
      that,
      that.items[location],
      currentPoint,
      { x: that.items[location].pos.x, y: that.items[location].pos.y },
      1000,
      function() {
      
      }
    );*/

    return true;
  }
  
  insertItem(angle, dropItem, pointer, notrigger) {
    let that = this;
    let tmpSize = Utils.getRealSizeItem(dropItem);
    var updateChange=false;
    let realSize=this.getCurrentCircuit() + tmpSize;
    if ( parseFloat((realSize-0.01).toFixed(2)) > this.ringSize) {
      if(!this._setSizeCircle(realSize)){
        this._trigger("onfull");
        return false;
      }
      this._trigger("onchangecircle"); 
      
      updateChange=true;
    }
    if(!updateChange){
      if (!dropItem.img) {
        fabric.Image.fromURL(
          dropItem.imageURL.replace(/^https:\/\//i, "http://"),
          function(img) {
            dropItem.updatePos(that.center);
            dropItem.updateSizes(img.width, img.height);
            img.set({
              left: dropItem.pos.x,
              top: dropItem.pos.y,
              scaleX: dropItem.scale,
              scaleY: dropItem.scale,
              angle: dropItem.pos.rotation
            });
  
            img.perPixelTargetFind = true;
            // that.FabricCanvas.add(img);
            dropItem.img = img;
            that._insertItem(that, angle, dropItem, pointer);
  
            if (notrigger !== true) {
              that._trigger("onchange");
            }
          },
          {
            crossOrigin: "anonymous",
            // remove borders and corners but leaving object available for events
            hasBorders: false,
            hasControls: false
          }
        );
      } else {
        this._insertItem(this, angle, dropItem, pointer);
        
        if (notrigger !== true) {
          this._trigger("onchange");
        }
      }
    }
    else
    {
      this._replaceDrawCicle(angle, dropItem, pointer);
    }
      
    return true;
  }

  _insertItem(that, angle, dropItem, p) {
    // let angle = that.pos2Angle(e.pointer, that.center);
    dropItem.angle = angle;
    dropItem.updatePos(that.center);

    // dropItem.img.selectable = that.zoom ? false : true;
    // dropItem.img.hoverCursor = that.zoom ? "move" : "pointer";
    that.FabricCanvas.add(dropItem.img);

    that.items.sort(function(a, b) {
      return a.angle - b.angle;
    });
    let item = that.items.find(function(o) {
      return angle < o.angle;
    });
    var i = that.items.indexOf(item);
    if (!item) {
      i = 0;
    }

    // insert current active object right before i
    let before =
      i === 0 ? that.items[that.items.length - 1] : that.items[i - 1];
    if (!before) {
      that.items.push(dropItem);
      if (p) {
        that.animating = true;
        Animation.animateLine(
          that,
          dropItem,
          p,
          { x: dropItem.pos.x, y: dropItem.pos.y },
          500,
          function() {
            that.animating = false;
          }
        );
      }
      return;
    }
    if (before === item) {
      before = null;
      dropItem.angle = angle;
      dropItem.updatePos(that.center);
    }
    // create a new array
    let tempArr = that.items.slice(i).concat(that.items.slice(0, i));
    // if (Utils.isBetweenAngle(angle, before.angle, minAngle)) {
    if (
      before &&
      Utils.isIntersectedCurves(
        before.getFirstAngle(),
        before.getLastAngle(),
        dropItem.getFirstAngle(),
        dropItem.getLastAngle()
      )
    ) {
      // get largest angle from last item
      var minAngle = Utils.normalizeAngle(
        before.getLastAngle() + dropItem.a / 2
      );
      dropItem.angle = minAngle;
      dropItem.updatePos(that.center);
    }
    var firstAngle = dropItem.getFirstAngle();
    var middleAngle = dropItem.angle;
    var lastAngle = dropItem.getLastAngle();
    that.animating = true;
    for (var j = 0; j < tempArr.length; j++) {
      var newAngle = lastAngle + tempArr[j].a / 2;
      if (
        Utils.isIntersectedCurves(
          firstAngle,
          lastAngle,
          tempArr[j].getFirstAngle(),
          tempArr[j].getLastAngle()
        ) ||
        Utils.isBetweenAngle(tempArr[j].angle, middleAngle, newAngle)
      ) {
        if (newAngle - Math.PI * 2 > tempArr[j].angle) {
          newAngle -= Math.PI * 2;
        } else if (newAngle < tempArr[j].angle) {
          newAngle += Math.PI * 2;
        }
      } else {
        newAngle = tempArr[j].angle;
      }
      Animation.animateItem2(
        that,
        tempArr[j],
        tempArr[j].angle,
        newAngle,
        500,
        j == tempArr.length - 1,
        function() {
          that.animating = false;
        }
      );
      firstAngle = Utils.normalizeAngle(newAngle - tempArr[j].a / 2);
      middleAngle = tempArr[j].angle;
      lastAngle = Utils.normalizeAngle(newAngle + tempArr[j].a / 2);
    }
    that.items.splice(i, 0, dropItem);
    if (p) {
      Animation.animateLine(
        that,
        dropItem,
        p,
        { x: dropItem.pos.x, y: dropItem.pos.y },
        500
      );
    }
  }

  clearItems() {
    for (var i = 0; i < this.items.length; i++) {
      this.FabricCanvas.remove(this.items[i].img);
    }
    this.FabricCanvas.renderAll();
    this.items = [];
  }

  drawNumber() {
    for (var i = 0; i < this.items.length; i++) {
      let pos = this.items[i].getNumberPos(this.center);
      var textObj = new fabric.Text(i+1+'', { 
        left: pos.x,
        top: pos.y,
        fontSize: this._getWidthBrowser() > MAX_WIDTH_SP ? 20 : 10,
        textAlign: "left",
        fill:"#FF0000"  // Set text color to red
      });
      this.numbers.push(textObj);
      this.FabricCanvas.add(textObj);
    }
  }

  clearNumber() {
    for (var i = 0; i < this.numbers.length; i++) {
      this.FabricCanvas.remove(this.numbers[i]);
    }
    this.FabricCanvas.renderAll();
    this.numbers = [];
  }

  toPNGBase64(showNumber = false) {
    var canvasW = this.FabricCanvas.getWidth();
    var canvasH = this.FabricCanvas.getHeight();
    this.FabricCanvas.zoomToPoint({ x: this.center.x, y: this.center.y }, 1);
    this.FabricCanvas.absolutePan({ x: 0, y: 0 });
    if (showNumber) {
      this.drawNumber();
    }

    if (canvasW > canvasH) {
      let data = this.FabricCanvas.toDataURL({
        format: "png",
        left: (canvasW - canvasH) / 2,
        width: canvasH,
        height: canvasH
      });
      if (showNumber) {
        this.clearNumber();
      }
      return data;
    }

    let data = this.FabricCanvas.toDataURL("png");
    if (showNumber) {
      this.clearNumber();
    }
    return data;
  }

  on(event, callback) {
    if (typeof callback === "function") {
      this._callbacks[event] = this._callbacks[event] || [];
      this._callbacks[event].push(callback);
    }
  }

  off(event, callback) {
    if (typeof callback === "function") {
      this._callbacks[event] = this._callbacks[event] || [];
      let idx = this._callbacks[event].indexOf(callback);
      if (idx >= 0) {
        this._callbacks[event].splice(idx, 0);
      }
    }
  }

  _trigger(event, data) {
    if (typeof this._callbacks[event] !== "undefined") {
      this._callbacks[event].forEach(cb => cb(data));
    }
  }

  _setSizeCircle(newSize){
    if(newSize>this.ringSizeMax){
      return false;
    }
    else
    if(newSize<this.ringSizeMin){
      if(this.ringSize<=this.ringSizeMin)
      {
        this.ringSize=this.ringSizeMin;
        return false;
      }
      newSize=this.ringSizeMin;
    }
     
     // console.log("_setSizeCircle Tool assss......change view ");
    //  console.log(newSize);
    this.lastR=this.r;
    this.ringSize=newSize;
    this.circleInfo.strokeWidth =this._getWidthBrowser() > MAX_WIDTH_SP ? 4 : 2;
    let radius = newSize / (2 * Math.PI); // radius in mm
    let percent = 0.5;
    if (newSize>= 1000) {
      percent = percent + 0.3;
    } else {
      percent =
        percent +
        (newSize / 100) *
          (this._getWidthBrowser() > MAX_WIDTH_SP ? 0.035 : 0.06);
    }
    let r_test = (Math.min(this.canvas.width, this.canvas.height) / 2) * percent; // radius in pixel
    DesignTool.unitRatio = r_test / radius;
    this.r = r_test;
    this.circuit = this.r * 2 * Math.PI;
    return true;
  }


  _replaceDrawCicle(angle, dropItem, pointer){
    let that=this;
    let numberItem=this.items.length;
    Animation.animateCircleToDraw( that,that.lastR,that.r ,2,
      function() {
       
      }
    );
    for(var i=0;i<numberItem;i++){
      Animation.animateItemChangeSize( that,that.lastR,that.r,i,numberItem ,4, (i==(numberItem-1)),
        function() {
          //console.log(" _replaceDrawCicle  _replaceDrawCicle");
          dropItem.circleRadius = that.r;
          if(dropItem.img){
              dropItem.updateSizes(dropItem.img.width, dropItem.img.height);
              dropItem.img.set({
                scaleX: dropItem.scale,
                scaleY: dropItem.scale
              });
          }
          that._insertItem(that, angle, dropItem, pointer);
          that._trigger("onchange");
          that.FabricCanvas.renderAll();
        }
      );
    }
  }

  _replaceDrawOldCicle(that){
    let numberItem=that.items.length;
    console.log(that.items);
    Animation.animateCircleToDraw( that,that.lastR,that.r ,4,
      function() {
      }
    );
    let pi=Math.PI*2;
    let cnpi=pi/that.ringSize;
    var sizeup=0;
    for(var i=0;i<numberItem;i++){
      let tmpSize= Utils.getRealSizeItem(that.items[i]);
      that.items[i].angle=(sizeup +tmpSize/2)*cnpi;
      that.items[i].angle=Utils.normalizeAngle(that.items[i].angle);
//      if(that.items[i].angle>(pi)) that.items[i].angle-=pi;
      sizeup+=tmpSize;
      console.log(that.items[i].angle);
    }
    for(var i=0;i<numberItem;i++){
        Animation.animateItemChangeSizeDown( that,that.lastR,that.r,i,numberItem ,5, (i==(numberItem-1)),
          function() {
        }); 
    }
  }
  
  stopAllCicle(){
    this.FabricCanvas.selection = false;
    /*this.FabricCanvas.forEachObject(function(o) {
        o.selectable = false;
      });*/
  } 
  startAllCicle(){
    let that=this;
    let numberItem=that.items.length;
    console.log(that.items);
    Animation.animateCircleToDraw( that,that.lastR,that.r ,4,
      function() {
      }
    );
    let pi=Math.PI*2;
    let cnpi=pi/that.ringSize;
    var sizeup=0;
    for(var i=0;i<numberItem;i++){
      let tmpSize= Utils.getRealSizeItem(that.items[i]);
      that.items[i].angle=(sizeup +tmpSize/2)*cnpi;
      that.items[i].angle=Utils.normalizeAngle(that.items[i].angle);
      sizeup+=tmpSize;
    }
    for(var i=0;i<numberItem;i++){
        Animation.animateItemChangeSizeDown( that,that.lastR,that.r,i,numberItem ,5, (i==(numberItem-1)),
          function() {
        }); 
    }
  } 

  _getWidthBrowser() {
    let width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    return width;
  }
}

export default CircleView;
